<template>
  <b-modal
    id="attendance-dashboard-modal"
    ref="modal"
    size="xl"
    hide-footer
    header-class="border-0 pb-0"
    @show="open = true"
    @hidden="open = false"
  >
    <template #modal-title>
      <span class="font-weight-bold text-primary">Front desk</span>
    </template>
    <attendance-desk v-if="mounted" :active="open" />
  </b-modal>
</template>

<script>
import AttendanceDesk from '../AttendanceDesk.vue'

/** Attendance Dashboard opened from Subscriptions › More. All logic lives in AttendanceDesk. */
export default {
  name: 'AttendanceDashboardModal',

  components: { AttendanceDesk },

  data() {
    return { open: false, mounted: false }
  },

  watch: {
    // Mount the desk on first open only, then keep it (and its camera/timers) for the page's life.
    open(val) { if (val) this.mounted = true },
  },

  methods: {
    show() {
      this.$refs.modal.show()
    },
  },
}
</script>
